import { MultipleItemResponse, fetchContent } from './fetchContent'
import { RolexStorePageV72024 } from './models/RolexStorePageV72024'

type Args = {
  language: string
  preview?: boolean
}
export const getAllRolexRetailers = async ({ language, preview }: Args) => {
  const response: MultipleItemResponse<RolexStorePageV72024> = await fetchContent({
    path: '',
    preview,
    params: {
      'system.type[in]': ['rolex_store_page_v7_2024'],
      language,
    },
  })

  return response
}
